/*
   首页table组件
   formKey 当前表需要的输出字段 请配合当前文件夹下的table组件下的filters进行阅读 
   url 当前表需要的url链接
*/
export default {
  Infos: {
    url: {
      0: "todo/index",
      1: "audit/lists",
      2: "tools/index",
    },
    formKey: {
      0: [
        { name: "提醒时间", key: "remind_time", Wid: 80 },
        { name: "提醒内容", key: "content", Wid: 190, type: "content" },
        { name: "创建时间", key: "create_time", Wid: 90 },
      ],
      1: [
        { name: "发起时间", key: "create_time", Wid: 150 },
        { name: "操作人", key: "user", Wid: 55, in: "uname", type: "obj" },
        { name: "操作类型", key: "action", Wid: 70, type: "action" },
        { name: "审核时间", key: "update_time", Wid: 150 },
        {
          name: "被告",
          key: "debtor",
          Wid: 55,
          in: "realname",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "证件号码/代码",
          key: "debtor",
          in: "chinaid",
          type: "obj",
          Wid: 140,
          inObjContent: true,
        },
        { name: "所属案件", key: "cause", Wid: 70, type: "sort", in: "sort" },
        {
          name: "审核状态",
          key: "status",
          type: "dict",
          Wid: 70,
          dict: "istatus",
        },
        {
          name: "操作内容",
          key: "content",
          Wid: 130,
          type: "content",
          inObjContent: true,
        },
        { name: "操作", key: "operation", Wid: 70 },
      ],
      2: [
        { name: "标题", key: "title", Wid: 80, type: "content" },
        { name: "内容", key: "content", Wid: 180, type: "content" },
        { name: "附件", key: "file_origin_name", Wid: 140, type: "content" },
        { name: "更新时间", key: "update_time", Wid: 100, type: "content" },
        { name: "操作", key: "operation", Wid: 75 },
      ],
    },
  },
  Over: {
    //进度超期
    formKey: [
      { name: "当前进度", key: "step_title", Wid: 95 },
      {
        name: "原告",
        key: "cause",
        Wid: 140,
        type: "obj",
        in: "title",
        inObjContent: true,
      },
      {
        name: "当前负责人",
        key: "cause",
        Wid: 76,
        type: "doubObj",
        in: ["step_user", "uname"],
        inObjContent: true,
      },
      {
        name: "所属案件",
        key: "cause",
        Wid: 65,
        type: "sort",
        in: "sort",
        inObjContent: true,
      },
      {
        name: "管辖法院",
        key: "cause",
        in: "court",
        Wid: 160,
        type: "obj",
        inObjContent: true,
      },
      { name: "被告", key: "realname", Wid: 65, inObjContent: true },
      { name: "证件号码/代码", key: "chinaid", Wid: 170, inObjContent: true },
      {
        name: "超期时间",
        key: "over_date",
        Wid: 90,
        inObjContent: true,
        type: "time",
      },
      // { name: "超期天数", key: "over_day", Wid: 70 },
      { name: "操作", key: "operation", Wid: 50 },
    ],
    url: { 0: "over/remind" },
  },
  Email: {
    //邮寄提醒
    formKey: [
      { name: "提醒时间", key: "over_date", Wid: 80 },
      {
        name: "操作人",
        key: "creater",
        Wid: 80,
        type: "obj",
        in: "nickname",
        inObjContent: true,
      },
      {
        name: "材料类型",
        key: "source",
        type: "dict",
        Wid: 70,
        dict: "source",
      },
      {
        name: "被告",
        key: "union_debtor",
        Wid: 80,
        in: "realname",
        type: "obj",
        inObjContent: true,
      },
      {
        name: "证件号码/代码",
        key: "union_debtor",
        in: "chinaid",
        type: "obj",
        Wid: 160,
      },
      { name: "所属案件", key: "cause", Wid: 70, type: "sort", in: "sort" },
      { name: "寄出时间", key: "ship_time", Wid: 80, type: "time" },
      { name: "材料名称", Wid: 180, key: "filename", type: "content" },
      { name: "操作", key: "operation", Wid: 70 },
    ],
    url: { 0: "shipRemind/receiveList" },
  },
  His: {
    formKey: {
      0: {
        0: [
          {
            name: "时间",
            key: "create_time",
            Wid: 115,
            inObjContent: true,
          },
          {
            name: "被告",
            key: "cause",
            Wid: 50,
            in: "realname",
            type: "obj",
            inObjContent: true,
          },
          {
            name: "证件号码/代码",
            key: "cause",
            Wid: 100,
            in: "chinaid",
            type: "obj",
            inObjContent: true,
          },
          {
            name: "原告",
            key: "cause",
            Wid: 120,
            in: "title",
            type: "obj",
            inObjContent: true,
          },
          {
            name: "沟通内容",
            key: "content",
            Wid: 215,
            type: "content",
            Array: ["content_user", "content"],
          },
          { name: "操作", key: "operation", Wid: 75 },
        ],
        1: [
          { name: "时间", key: "create_time", Wid: 100 },
          {
            name: "被告",
            key: "debtor",
            Wid: 40,
            in: "realname",
            type: "obj",
            inObjContent: true,
          },
          {
            name: "证件号码/代码",
            key: "debtor",
            Wid: 100,
            in: "chinaid",
            type: "obj",
            inObjContent: true,
          },
          { name: "沟通内容", key: "expand_say", Wid: 240, type: "content" },
          { name: "操作", key: "operation", Wid: 75 },
        ],
      },
      1: [
        { name: "新增时间", key: "create_time", Wid: 90 },
        {
          name: "被告",
          key: "debtor",
          Wid: 40,
          in: "realname",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "证件号码/代码",
          key: "debtor",
          Wid: 100,
          in: "chinaid",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "原告",
          key: "cause",
          Wid: 100,
          in: "title",
          type: "obj",
          inObjContent: true,
        },
        { name: "所属案件", key: "cause", Wid: 50, type: "sort", in: "sort" },
        { name: "新增进度 ", key: "title", Wid: 100, type: "content" },
      ],
      2: [
        { name: "新增时间", key: "create_time", Wid: 90 },
        { name: "操作人", key: "creator", Wid: 40, in: "uname", type: "obj" },
        { name: "被告", key: "realname", Wid: 40, inObjContent: true },
        { name: "证件号码/代码", key: "chinaid", Wid: 100, inObjContent: true },
        { name: "户籍所在地", key: "addr_concat", Wid: 200, type: "content" },
      ],
      3: [
        { name: "时间", key: "create_time", Wid: 90 },
        {
          name: "被告",
          key: "debtor",
          Wid: 40,
          in: "realname",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "证件号码/代码",
          key: "debtor",
          Wid: 110,
          in: "chinaid",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "原告",
          key: "cause",
          Wid: 120,
          in: "title",
          type: "obj",
          inObjContent: true,
        },
        { name: "材料名称", key: "filename", Wid: 120, type: "content" },
        { name: "操作", key: "operation", Wid: 75 },
      ],
    },
    url: {
      0: "cause/comments/remind",
      1: "actionLog/newCauseStepRemind",
      2: "debtor/newDebtorRemind/list",
      3: "shipRemind/index",
    },
  },
  Payback: {
    //分期
    formKey: [
      { name: "被告", key: "realname", Wid: 80, inObjContent: true },
      { name: "证件号码/代码", key: "chinaid", Wid: 150, inObjContent: true },
      {
        name: "原告",
        key: "cause",
        Wid: 180,
        type: "obj",
        in: "title",
        inObjContent: true,
      },
      {
        name: "所属案件",
        key: "cause",
        Wid: 70,
        type: "sort",
        in: "sort",
        inObjContent: true,
      },
      {
        name: "管辖法院",
        key: "cause",
        in: "court",
        Wid: 200,
        type: "obj",
        inObjContent: true,
      },
      { name: "期数", key: "period_count", Wid: 50 },
      { name: "金额", key: "fee", Wid: 90, type: "yuan" },
      { name: "应履行时间", key: "time", Wid: 90, type: "time" },
      { name: "操作", key: "operation", Wid: 50 },
    ],
    url: {
      0: "credit/loan/future_pay_List", //即將逾期
      1: "credit/loan/overdue", //已逾期
    },
  },
  Collect: {
    //保全
    formKey: [
      { name: "保全时间", key: "stime", Wid: 100, type: "time" },
      {
        name: "被告",
        key: "debtor",
        in: "realname",
        Wid: 70,
        type: "obj",
        inObjContent: true,
      },
      {
        name: "证件号码/代码",
        key: "debtor",
        in: "chinaid",
        Wid: 130,
        type: "obj",
        inObjContent: true,
      },
      {
        name: "原告",
        key: "debtor",
        Wid: 190,
        in: "title",
        type: "obj",
        inObjContent: true,
      },
      { name: "保全到期时间", key: "etime", Wid: 100, type: "time" },
      { name: "资产信息", key: "content", Wid: 0, type: "content" },
      { name: "操作", key: "operation", Wid: 60 },
    ],
    url: {
      0: "debtor/keep/expired", //到期
      1: "debtor/keep/expire", //即将到期
    },
  },
  Time: {
    formKey: {
      1: [
        {
          name: "被告",
          key: "debtor",
          Wid: 50,
          in: "realname",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "证件号码/代码",
          key: "debtor",
          Wid: 140,
          in: "chinaid",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "原告",
          key: "debtor",
          Wid: 180,
          type: "accuser",
          inObjContent: true,
        },
        {
          name: "最后代偿时间",
          key: "debtor",
          in: "last_compensation_time",
          Wid: 120,
          type: "inTime",
        },
        { name: "本案代偿时间", key: "debtor", Wid: 120, type: "special" },
        { name: "操作", key: "operation", Wid: 60 },
        // { name: '提醒时间', key: 'update_time', Wid: 120 }
      ],
      2: [
        {
          name: "被告",
          key: "debtor",
          Wid: 50,
          in: "realname",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "证件号码/代码",
          key: "debtor",
          Wid: 140,
          in: "chinaid",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "原告",
          key: "debtor",
          Wid: 180,
          type: "accuser",
          inObjContent: true,
        },
        {
          name: "最后代偿时间",
          key: "debtor",
          in: "last_compensation_time",
          Wid: 120,
          type: "inTime",
        },
        { name: "本案代偿时间", key: "debtor", Wid: 120, type: "special" },
        { name: "操作", key: "operation", Wid: 70 },
        // { name: '延期时间', key: 'delay_time', Wid: 120 }
      ],
    },
    url: "welcome/causeAging/index",
  },
  Carry: {
    formKey: {
      1: [
        {
          name: "被告",
          key: "debtor",
          Wid: 60,
          in: "realname",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "证件号码/代码",
          key: "debtor",
          Wid: 120,
          in: "chinaid",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "原告",
          key: "accuser",
          Wid: 170,
          in: "title",
          type: "obj",
          inObjContent: true,
        },
        { name: "所属案件", Wid: 50, type: "sort", key: "sort" },
        { name: "管辖法院", key: "court", Wid: 200, type: "content" },
        {
          name: "文书类别",
          key: "type",
          Wid: 80,
          type: "dict",
          dict: "bookType",
        },
        { name: "操作", key: "operation", Wid: 60 },
      ],
      2: [
        {
          name: "被告",
          key: "debtor",
          Wid: 60,
          in: "realname",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "证件号码/代码",
          key: "debtor",
          Wid: 120,
          in: "chinaid",
          type: "obj",
          inObjContent: true,
        },
        {
          name: "原告",
          key: "accuser",
          Wid: 120,
          in: "title",
          type: "obj",
          inObjContent: true,
        },
        { name: "所属案件", Wid: 50, type: "sort", key: "sort" },
        { name: "管辖法院", key: "court", Wid: 200, type: "content" },
        {
          name: "文书类别",
          key: "type",
          Wid: 80,
          type: "dict",
          dict: "bookType",
        },
        { name: "操作", key: "operation", Wid: 75 },
      ],
    },
    url: "step/cpws/remind",
  },
  Auction: {
    formKey: [
      { name: "提醒时间", Wid: 120, key: "create_time" },
      // { name: '操作人', key: 'creater', Wid: 60, type: 'obj', in: 'nickname', inObjContent: true },
      {
        name: "被告",
        key: "debtor",
        Wid: 60,
        type: "obj",
        in: "realname",
        inObjContent: true,
      },
      {
        name: "证件号码/代码",
        key: "debtor",
        Wid: 110,
        type: "obj",
        in: "chinaid",
        inObjContent: true,
      },
      {
        name: "拍卖类型",
        key: "item_type",
        type: "dict",
        dict: "item_type",
        Wid: 54,
      },
      {
        name: "拍卖阶段",
        key: "auction_step",
        type: "dict",
        Wid: 54,
        dict: "auction_step",
      },
      {
        name: "拍卖状态",
        key: "auction_status",
        type: "dict",
        dict: "auction_status",
        Wid: 54,
      },
      { name: "拍卖开始时间", key: "auction_start_time", Wid: 114 },
      { name: "拍卖物品名称", key: "title", Wid: 75, type: "content" },
      { name: "操作", key: "operation", Wid: 75 },
    ],
    url: {
      0: "auction/inAuctionRemind",
      1: "auction/willAuctionRemind",
    },
  },
};
